<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外教对接中心</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <i-col :xs="6" :sm="6" :md="6">
            <Form-item label="反馈时间">
              <Col span="11">
                <Date-picker
                 type="date" format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  @on-change="startDateChange"
                  v-model="queryParam.startDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
              <Col span="2" style="text-align: center">-</Col>
              <Col span="11">
                <Date-picker
                 type="date" format="yyyy-MM-dd"
                  placeholder="请选择日期"
                  @on-change="endDateChange"
                  v-model="queryParam.endDate"
                  style="width: 100%;"
                ></Date-picker>
              </Col>
            </Form-item>
          </i-col>
          <i-col :xs="5" :sm="5" :md="5">
            <Form-item label="老师ID" prop="tchId">
              <Input name="tchId" v-model="queryParam.tchId"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="5" :sm="5" :md="5">
            <Form-item label="老师名称" prop="tchName">
              <Input name="tchName" placeholder="支持模糊搜索" v-model="queryParam.tchName"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="5" :sm="5" :md="5">
            <Form-item label="反馈内容" prop="content">
              <Input name="content" placeholder="支持模糊搜索" v-model="queryParam.content"></Input>
            </Form-item>
          </i-col>
          <!-- <i-col :xs="6" :md="3">
            <Form-item label="反馈类型" prop="tchType">
              <Select v-model.number="queryParam.tchType" placeholder="全部"
                      @on-change="search" clearable data-value="-1">
                <Option value="-1">全部</Option>
                <Option value="0">加开固定时间</Option>
                <Option value="1">加开临时时间</Option>
                <Option value="2">上课反馈</Option>
                <Option value="3">体验课上课要求</Option>
              </Select>
            </Form-item>
          </i-col> -->
          <i-col :xs="5" :md="3">
            <Form-item label="是否完结">
              <Select v-model="queryParam.completed" placeholder="全部" @on-change="search" clearable>
                <Option value='0'>否</Option>
                <Option value='1'>是</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="5" :md="3">
            <Form-item label="审批状态">
              <Select v-model="queryParam.auditStatus" placeholder="全部" @on-change="search" clearable>
                <Option value="0">待审批</Option>
                <Option value="1">已通过</Option>
                <Option value="2">未通过</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="5" :sm="5" :md="5">
            <Form-item label="反馈人" prop="creator">
              <Input name="creator" placeholder="ID、名字" v-model="queryParam.creator"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="10">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="primary" @click="addTch" icon="plus">添加反馈</Button>
          </i-col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage"
          listUrl="/stageReport/fm-message-list" class="pay-list"
          :params="queryParam" :onLoading="onLoading"></List>

    <LessonFeedbackDealModal :feedBackParamData="feedBackParamData" :successCallback="search" :timeList="timeList"
                   v-model="showLessonFeedbackDealModal"></LessonFeedbackDealModal>
    <AddMatchCenterModal :successCallback="search" v-model="showAddMatchCenterModal"></AddMatchCenterModal>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId"
                    :successCallback="searchWithPage"></tch-info-modal>
  </div>
</template>
<script>
import TchCancelOpenedTimeModal from './TchCancelOpenedTimeModal.vue'
import TchAddOpenedTimeModal from './TchAddOpenedTimeModal.vue'
import TchEditOpenedTimeModal from './TchEditOpenedTimeModal.vue'
import TchCancelRandomOpenedTimeModal from './TchCancelRandomOpenedTimeModal.vue'
import TchAddRandomOpenedTimeModal from './TchAddRandomOpenedTimeModal.vue'
import TchLeaveModal from './TchLeaveModal.vue'
import TchLeaveOfficeModal from './TchLeaveOfficeModal.vue'
import AssignTchStudyAdviserModal from './modal/AssignTchStudyAdviserModal.vue'
import TchInsertModal from './TchInsertModal.vue'
import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import AllTeachersLeaveModal from './AllTchLeaveModal'
import EditDingDingModal from './modal/EditDingDingModal'
import TeachersDingTalkModal from './modal/TeachersDingTalkModal'
import SubstituteTchSelect from '@/components/common/SubstituteTchSelect'
import ExportLeaveModal from './ExportLeaveModal.vue'
import AdminUserMultSelect from '../common/AdminUserMultSelect.vue'
import ResignModal from './ResignModal.vue'
import LessonFeedbackDealModal from '../../components/lesson/modal/LessonFeedbackDealModal.vue'
import AddMatchCenterModal from './modal/AddMatchCenterModal.vue'
import { enabled } from 'store'

export default {
  components: {
    AdminUserMultSelect,
    ExportLeaveModal,
    TeachersDingTalkModal,
    EditDingDingModal,
    TchCancelOpenedTimeModal,
    TchAddOpenedTimeModal,
    TchEditOpenedTimeModal,
    TchCancelRandomOpenedTimeModal,
    TchAddRandomOpenedTimeModal,
    TchLeaveModal,
    TchLeaveOfficeModal,
    AssignTchStudyAdviserModal,
    TchInsertModal,
    AllTeachersLeaveModal,
    TchInfoModal,
    SubstituteTchSelect,
    ResignModal,
    LessonFeedbackDealModal,
    AddMatchCenterModal
  },
  data () {
    let $moment = this.$moment
    let $constant = this.$constant
    let self = this
    return {
      uploadLeaveUrl: this.$appConfig.baseUrl + '/bookTchLeaveTime/importExe',
      fileList: [],
      headers: {},
      activityList: [],
      substituteList: [],
      lsnBeginTime: '',
      searchLoading: false,
      rankScoreSeq: 0,
      loadingEdit: false,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      tchId: null,
      tchTags: [],
      tchTagPermission: false,
      queryParam: {
        creator: '',
        tchId: '',
        tchName: '',
        content: '',
        startDate: '',
        endDate: '',
        completed: '0',
        auditStatus: '',
        bizTypes: ['加开固定时间', '上课反馈', '外教回复', '加开临时时间', '其他', '加开短期固定时间', '开绑定权限', '开临时约课权限']
      },
      showEditDingModal: false,
      showTeacherDingTalkModal: false,
      tchInsertModal: false,
      teacherCategoryList: [{code: 2, text: '正式老师'}, {code: 1, text: '试用期老师'}, {code: 3, text: '工作人员'}],
      studyAdviserList: [],
      showTchAddOpenedTimeModal: false,
      showTchEditOpenedTimeModal: false,
      showTchCancelOpenedTimeModal: false,
      showTchAddRandomOpenedTimeModal: false,
      showCancelRandomOpenedTimeModal: false,
      showTchLeaveModal: false,
      showEditTagsModal: false,
      showTchLeaveOfficeModal: false,
      showAssignTchStudyAdviserModal: false,
      showAllTeacherLeaveModel: false,
      showExportLeaveModal: false,
      selectionTch: [],
      showSelectTch: false,
      showTchResignModal: false,
      showLessonFeedbackDealModal: false,
      showAddMatchCenterModal: false,
      feedBackParamData: {},
      timeList: [],
      resignTitle: '',
      substituteTchId: '',
      selectTchParam: {
        lessonTime: '',
        name: '',
        tchStudyAdviser: '', // 学习导师
        adviser: '', // 课程顾问
        openedId: null,
        substituteTchId: ''
      },
      title: [
        {
          title: '反馈人',
          width: 80,
          align: 'center',
          key: 'fromUser'
        },
        {
          title: '反馈时间',
          width: 120,
          align: 'center',
          key: 'createTime',
        },
        {
          title: '反馈端口',
          width: 100,
          align: 'center',
          key: 'bizFrom',
        },
        {
          title: '反馈类型',
          width: 130,
          align: 'center',
          key: 'bizType'
        },
        {
          title: '反馈内容',
          key: 'feedContent',
          width: 200,
          align: 'center',
          render: (h, params) => {
            let feedContent = params.row.feedContent
            let lessonTime = params.row.lessonTime
            let bizType = params.row.bizType
            if (['加开固定的时间', '加开固定时间', '加开短期固定时间'].includes(bizType)) {
              try {
                const list = JSON.parse(feedContent)
                let spanArr = []
                if (list) {
                  list.forEach(function (set) {
                    let timeText = `${set.weekStr} ${set.startTimeStr || '00:00'} - ${set.endTimeStr}，生效时间：${set.useDateStr}`
                    if (set.endDateStr) {
                      timeText += `，失效时间：${set.endDateStr || set.endDateStr}`
                    }
                    spanArr.push(h('span', [h('span', {style: {color: '#2d8cf0'}}),
                      h('span', timeText)]))
                    spanArr.push(h('br'))
                  })
                }
                return h('div', {style: {'font-size': '12px'}}, [h('p', spanArr)])
              } catch (e) {
                return h('span', feedContent)
              }
            } else if (bizType === '加开临时时间') {
              try {
                const list = JSON.parse(feedContent)
                let spanArr = []
                if (list) {
                  list.forEach(function (set) {
                    spanArr.push(h('span', [h('span', {style: {color: '#2d8cf0'}}),
                      h('span', `${set.dayStr} ${set.startTimeStr} - ${set.endTimeStr}`)]))
                    spanArr.push(h('br'))
                  })
                }
                return h('div', {style: {'font-size': '12px'}}, [h('p', spanArr)])
              } catch (e) {
                return h('span', feedContent)
              }
            } else if (bizType === '体验课上课要求') {
              if (feedContent && feedContent.includes('|')) {
                // 按竖线分割内容
                const parts = feedContent.split('|')
                const firstPart = parts[0] // 第一部分直接展示
                const secondPart = parts[1] // 第二部分作为标签

                // 解析第二部分的标签（去除方括号、引号并按逗号分割）
                let tags = []
                if (secondPart) {
                  // 移除方括号和引号并按逗号分割
                  let tagsString = secondPart.replace(/[[\]"']/g, '') // 移除方括号和引号
                  if (tagsString.trim()) {
                    tags = tagsString.split(',').map(tag => tag.trim()).filter(tag => tag)
                  }
                }

                // 创建渲染元素数组
                const children = []

                // 添加第一部分内容
                if (firstPart) {
                  children.push(h('div', { style: 'margin-bottom: 5px;' }, firstPart))
                }

                // 添加标签
                if (tags.length > 0) {
                  // 定义不同类型的标签颜色，使用高对比度颜色确保清晰可见
                  const tagColors = ['green', 'orange', 'red', 'blue', 'purple']

                  const tagElements = tags.map((tag, index) => {
                    return h('Tag', {
                      props: {
                        color: tagColors[index % tagColors.length],
                        closable: false
                      },
                      style: {
                        margin: '2px 5px 2px 0',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }
                    }, tag)
                  })

                  children.push(h('div', {
                    style: 'display: flex; flex-wrap: wrap; align-items: center;'
                  }, tagElements))
                }

                return h('div', children)
              } else {
                // 如果没有竖线，直接显示内容
                return h('span', feedContent)
              }
            } else {
              if (lessonTime) {
                return h('div', { style: 'display: flex; flex-direction: column;'}, [
                  h('a', {on: {click: () => this.openLessonList(params.row.bookLessonOpenedId)}}, lessonTime),
                  h('span', feedContent),
                ])
              } else {
                return h('span', feedContent)
              }
            }
          }
        },
        {
          title: '学生ID、名称',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let uid = params.row.uid
            let stdName = params.row.stdName
            let str = '-'
            if (uid) {
              str = uid + '-' + stdName
            }
            if (str === '-') {
              return h('span', '-')
            } else {
              return h('div', [
                h('a', {on: {click: () => this.openInfoModal(uid)}}, uid + '-' + stdName)
              ])
            }
          }
        },
        {
          title: '老师ID、名称',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.tchId) {
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchName,
                score: row.monthRankScore,
                onClick: () => this.openTchInfoModal(row.tchId)
              })
            } else {
              return h('span', '-')
            }
          }
        },
        {
          title: 'sc/cc',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let scName = params.row.scName
            let ccName = params.row.ccName
            return h('div', [
              h('div', scName || '-'),
              h('div', ccName || '-')
            ])
          }
        },
        {
          title: '是否完结',
          width: 70,
          align: 'center',
          key: 'completed',
          render: (h, params) => {
            let completed = params.row.completed
            let completedEnum = $constant.getEnum($constant.yesOrNo, completed)
            return h('span', completedEnum && completedEnum.text)
          }
        },
        {
          title: '审批状态',
          key: 'auditStatus',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let auditStatus = params.row.auditStatus
            let auditStatusEnum = $constant.getEnum($constant.auditStatus, auditStatus)
            return h('span', auditStatusEnum && auditStatusEnum.text)
          }
        },
        {
          title: '审批人',
          key: 'auditorName',
          width: 100,
          align: 'center',
        },
        {
          title: '审批意见',
          key: 'auditRemark',
          width: 120,
          align: 'center',
        },
        {
          title: '是否展示给老师',
          key: 'showTch',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let showTch = params.row.showTch
            let showTchEnum = $constant.getEnum($constant.yesOrNo, showTch)
            return h('span', showTchEnum && showTchEnum.text)
          }
        },
        {
          title: '老师是否收到',
          key: 'received',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let received = params.row.received
            let receivedEnum = $constant.getEnum($constant.yesOrNo, received)
            return h('span', receivedEnum && receivedEnum.text)
          }
        },
        {
          title: '老师确认',
          key: 'tchConfirm',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const tchConfirmEnum = [
              {code: 0, text: '未回复'},
              {code: 1, text: '同意'},
              {code: 2, text: '拒绝'}
            ]
            let tchConfirm = params.row.tchConfirm
            let tchConfirmItem = $constant.getEnum(tchConfirmEnum, tchConfirm)
            return h('span', (tchConfirmItem && tchConfirmItem.text) || '未回复')
          }
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              },
            }, [
              h(
                'a',
                {
                  on: {
                    click: () => {
                      if (params.row.auditStatus != 0 || params.row.completed) {
                        return
                      }
                      this.showLessonFeedbackDealModal = true
                      if (['加开固定时间', '加开临时时间'].includes(params.row.bizType)) {
                        this.timeList = JSON.parse(params.row.feedContent)
                      } else {
                        this.timeList = []
                      }
                      this.feedBackParamData = { ...params.row, showTch: params.row.showTch === true ? 1 : 0 }
                    },
                  },
                  style: {
                    color: (params.row.auditStatus == 0 && !params.row.completed) ? '#2d8cf0' : 'gray',
                  },
                },
                '审批'
              ),
              h(
                'a',
                {
                  on: {
                    click: () => {
                      if (params.row.completed) {
                        return
                      }
                      this.handleEnd(params.row)
                    },
                  },
                  style: {
                    color: params.row.completed ? 'gray' : '#2d8cf0',
                  },
                },
                '完结'
              ),
            ])
          }
        }
      ]
    }
  },
  created: function () {
  },
  methods: {
    openLessonList (val) {
      let {href} = this.$router.resolve({
        name: 'bookLessonOpenedList',
        query: {bookLessonOpenedId: val, pageIndex: 1, pageSize: 10}})
      window.open(href, '_blank')
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookUserLeaveTimeList'}})
      window.open(href, '_blank')
    },
    startDateChange (value) {
      this.queryParam.startDate = value
    },
    endDateChange (value) {
      this.queryParam.endDate = value
    },
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    closeModal (val) {
      this.uid = null
      this.editUser = val
    },
    search () {
      this.reload = new Date().getTime()
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    if (!loading) {
      this.loadMonthRankScores()
    }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },
    addTch () {
      this.showAddMatchCenterModal = true
      this.tchId = null
    },
    handleEnd (row) {
      this.$http.post(`/stageReport/fm-message-completed?id=${row.id}`).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('完结成功')
          this.search()
        } else {
          this.$Message.error('完结失败')
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 10px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}
.btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// ForeignTchMatchCenter.vue?48537573